import { ValidationError } from "../api";

export const isValidationError = (err: unknown): err is ValidationError => {
  return (
    err !== null &&
    typeof err === "object" &&
    "errors" in err &&
    typeof (err as ValidationError).errors === "object"
  );
};

export const formatValidationError = (err: ValidationError): string => {
  return Object.entries(err.errors!)
    .map(([field, msg]) => `${field}: ${msg}`)
    .join(". ");
};
